import React from 'react';
import 'primereact/resources/themes/saga-blue/theme.css';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';

export default function Header() {

    return (
    <header
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        padding: "0 1rem",
        height: "60px",
        backgroundColor: "#c3e7d1",
        color: "black",
        position: "relative",
      }}
    >
      {/* === Logo à gauche === */}
      <img
        src="/CampusFaso_Logo.png"
        alt="Logo CampusFaso"
        height="40"
        style={{ objectFit: "contain" }}
      />

      {/* === Texte centré (visible seulement sur desktop) === */}
      <div
        className="header-text"
        style={{
          position: "absolute",
          left: 0,
          right: 0,
          textAlign: "center",
          fontWeight: "bold",
          fontSize: "1rem",
          fontStyle: "italic",
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
        }}
      >
        Authentification des diplômes des étudiants issus de la plateforme
        CAMPUSFASO
      </div>

      <div style={{ width: "40px" }}></div>

      <style>
        {`
          @media (max-width: 768px) {
            .header-text {
              display: none; /* On cache le texte sur mobile et tablette */
            }
          }
        `}
      </style>
    </header>
  );
}
